// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3FL2m","requiredAsterisk":"Info_requiredAsterisk__pyqzl"};